/*
  Extras da esteira de compra entram no carrinho junto com o produto:
  - acessórios marcados no HALO Compre junto (blocks/halo-compre-junto.liquid);
  - opções pagas escolhidas nos blocos HALO Escolha (ex.: estojo, garantia), com a
    informação do item (propriedade) quando configurada.

  Fluxo (aprovado pelo Pedro; arquivos do botão e da Yampi intactos):
  - No clique de "Adicionar ao carrinho" (ou do botão da barra fixa) com algum extra, o
    clique é segurado, os extras são adicionados pela API do carrinho da Shopify
    (/cart/add.js) e o mesmo clique é repetido para o tema adicionar o produto e abrir o
    carrinho, que já mostra tudo junto.
  - Sem extra nenhum, nada muda. Se o tamanho ainda não foi escolhido (estilo HALO do
    seletor), não faz nada: a trava do tamanho age primeiro e nenhum extra entra.
  - Se um extra falhar (ex.: esgotou), o produto principal segue para o carrinho e um aviso
    aparece (no Compre junto ou no resumo).
  - Depois de adicionar, as escolhas continuam marcadas (o cliente fecha o carrinho e vê o que
    escolheu). Se clicar em adicionar de novo, os extras que já estão no carrinho não entram
    outra vez; só o produto e os extras que faltam.
*/
(function () {
  'use strict';

  if (window.haloCompreJunto) return;
  window.haloCompreJunto = true;

  var passing = false;

  // Seção de produto que tem extras (Compre junto ou Escolha).
  function root() {
    var el = document.querySelector('[data-hcj], [data-halo-escolha]');
    return el ? el.closest('xo-product') || document : null;
  }

  function selected(scope) {
    return Array.prototype.slice.call(
      scope.querySelectorAll('[data-hcj-check]:checked:not(:disabled), [data-halo-opcao]:checked:not(:disabled)')
    );
  }

  // Tamanho obrigatório ainda não escolhido (estilo HALO do seletor de variantes).
  function sizePending() {
    var picker = document.querySelector('.halo-picker[data-halo-require-size]');
    return !!(picker && picker.dataset.haloSizeChosen !== 'true' && picker.querySelector('[data-halo-size]'));
  }

  // Só os botões que compram o produto desta página: formulário de compra dentro da mesma
  // seção de produto dos extras, ou o botão da barra fixa.
  function buysThisProduct(el, scope) {
    if (el.closest('[data-sticky-atc-submit]')) return true;
    var form = el.closest('form[action*="/cart/add"]');
    return !!(form && scope !== document && scope.contains(form));
  }

  function cartAddUrl() {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return base + 'cart/add.js';
  }

  function toItem(input) {
    var item = { id: Number(input.value), quantity: 1 };
    if (input.dataset.propNome && input.dataset.propValor) {
      item.properties = {};
      item.properties[input.dataset.propNome] = input.dataset.propValor;
    }
    return item;
  }

  function cartUrl() {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return base + 'cart.js';
  }

  // Extras que ainda não estão no carrinho (evita duplicar quando o cliente adiciona de novo).
  function missing(inputs) {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : { items: [] };
      })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) {
          inCart[item.variant_id] = true;
        });
        return inputs.filter(function (input) {
          return !inCart[Number(input.value)];
        });
      })
      .catch(function () {
        return inputs;
      });
  }

  function showError(scope) {
    var status = scope.querySelector('[data-hcj-status]');
    if (status) status.textContent = status.dataset.error || '';
  }

  document.addEventListener('click', function (e) {
    if (passing) return;
    var button = e.target.closest && e.target.closest('xo-cart-add, [name="add"], [type="submit"], [data-sticky-atc-submit]');
    if (!button) return;
    // O clique é repetido no mesmo elemento que o cliente clicou (o botão de verdade),
    // onde o tema e a barra fixa escutam.
    var clicked = e.target.closest('button, [type="submit"], [data-sticky-atc-submit]') || button;
    var scope = root();
    if (!scope || !buysThisProduct(button, scope)) return;
    var inputs = selected(scope);
    if (!inputs.length || sizePending()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (scope.haloBusy) return;
    scope.haloBusy = true;

    var status = scope.querySelector('[data-hcj-status]');
    if (status) status.textContent = '';

    missing(inputs)
      .then(function (toAdd) {
        if (!toAdd.length) return;
        return fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: toAdd.map(toItem) }),
        }).then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
        });
      })
      .catch(function () {
        showError(scope);
      })
      .then(function () {
        scope.haloBusy = false;
        // Repete o clique para o tema adicionar o produto e abrir o carrinho.
        passing = true;
        try {
          clicked.click();
        } finally {
          passing = false;
        }
      });
  }, true);

  // Trocar a variação de um acessório (ex.: cor da capa) atualiza o item, a foto e o preço, e já o marca.
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-hcj-variant]');
    if (!pill || pill.disabled) return;
    var item = pill.closest('[data-hcj-item]');
    var input = item && item.querySelector('[data-hcj-check]');
    if (!input) return;
    item.querySelectorAll('[data-hcj-variant]').forEach(function (other) {
      other.setAttribute('aria-pressed', other === pill ? 'true' : 'false');
    });
    input.value = pill.dataset.hcjVariant;
    if (pill.dataset.preco) input.dataset.hcjPreco = pill.dataset.preco;
    // Foto da variante escolhida (ex.: capa Chumbo).
    if (pill.dataset.imagem) {
      var media = item.querySelector('.halo-compre-junto__media');
      var img = media && media.querySelector('img');
      if (media && !img) {
        media.textContent = '';
        img = document.createElement('img');
        img.alt = '';
        img.sizes = '52px';
        media.appendChild(img);
      }
      if (img) {
        img.srcset = pill.dataset.imagemSrcset || '';
        img.src = pill.dataset.imagem;
      }
    }
    input.checked = true;
    document.dispatchEvent(new CustomEvent('halo:extras'));
  });
})();
